export const m = {
  EnterID: "ажмите, чтобы ввести идентификатор Tada",
  "select-specifications":
    "ажмите, чтобы выбрать спецификацию пополнения счета",
  "check-account": "роверьте счет пополнения",
  whatID: "то такое идентификатор Tada?",
  getID: "ведите идентификатор Tada",
  maskgetID: "Введите идентификатор Tada",
  "toastTips-format-error": "еверный формат ввода",
  "toastTips-no-exist": "дентификатор не существует",
  toastTipsPlease: "ожалуйста, сначала проверьте счет пополнения",
  "common-problem": "бщая проблема",
  "transaction-succeeded": "ранзакция успешна",
  "transaction-failed": "ранзакция не удалась",
  "transaction-cancel": "ранзакция была отменена",
  "whether-account":
    ".Как я могу проверить,получил ли я пополнение после пополнения счета?",
  "answer-whether-account":
    "осле пополнения вы можете вернуться к [Мой] - [Бумажник] в приложении, чтобы проверить алмазы.",
  "no-account":
    ".Что мне делать, если я не получаю пополнение после пополнения счета?",
  "answer-no-account":
    "ожалуйста, отправьте свои вопросы в [Сообщение] - [Официальные новости] - [Обратная связь и помощь] приложения, и предоставьте следующую информацию, наша служба поможет дать вам поддержки.",
  "recharge-money": "1. Сумма пополнения и идентификатор счета.",
  "recharge-time": "2. Время и дата перезарядки.",
  "recharge-shot": "3. Скриншот успешной оплаты.",
  "recharge-wrong":
    ".Что мне делать, если я списываю с неверной учетной записи и взимаю неправильную сумму?",
  "answer-recharge-wrong":
    "режде чем вводить платежный пароль, убедитесь, что перед покупкой тщательно подтвердили идентификатор счета и сумму пополнения. Невозможно вернуть сумму за неправильную оплату. Для учетной записи с неправильной оплатой вы можете попытаться связаться с пользователем с идентификатором, который фактически зарядил, и договориться с другой стороной, если вы хотите компенсировать свою плату.",
  refund: ".Возвращать деньги",
  "answer-refund":
    "ожалею! Tada в настоящее время не поддерживает возврат средств.",
  "buy-enter-link":
    'окупку бриллиантов можно пополнить по ссылке, <a class="web-link" href="https://pay.tadachat.info/" >https://pay.tadachat.info</a>, скопируйте ссылку, чтобы открыть в мобильном браузере, перейдите на страницу покупки, проверьте учетную запись, выберите соответствующие спецификации и используйте соответствующий способ для оплаты ~ Много скидок!',
  "buy-notice-a":
    "римечание:<a>pay.tadachat.info</a> является единственным официальным сайтом для покупки бриллиантов в Tada.",
  replace: "амещать",
  sureBtn: "ОРОШО",
  "pay-style": "ыберите способ оплаты",
  goBack: "ернуться на главную страницу",
  toastTips: "ведите идентификатор Tada",
  rechargeFAQ_title: "бщая проблема",
  PayStatusSuccess_title: "ранзакция успешна",
  PayStatusFail_title: "ранзакция не удалась",
  PayStatusCancel_title: "ранзакция была отменена",
  Diamonds_title: "aceCast Алмазной перезарядка Официальный сайт",
  "buy-notice":
    "римечание pay.tadachat.info является Tada только официальный сайт покупки алмазов, пожалуйста, [Сообщение] - [Официальные новости] - [Обратная связь и помощь]",
  RechargeHelp_title: "омощь по пополнению",
  openAPP: "ткрыть приложение Tada",
  "buy-diamonds-tit": "упить алмазные услуги",
  description:
    "aceCast Единственный официальный сайт для пополнения бриллиантов, Tada - это международное социальное программное обеспечение, пользователи которого используют более 150 стран и регионов по всему миру.",
  keywords:
    "ополнение Tada, пополнение Tada с бриллиантами, официальное пополнение Tada, официальный сайт пополнения Tada",
  "payforType": " Способ пополнения",
  trueText: "ХОРОШО",
  falseText: " Отмена",
  alertShowTxt1: "Вы уверены, что используете",
  alertShowTxt3: "для пополнения запасов",
  alertShowTxt5: "алмазов?",
  EnterIDTip: "aceCast быстрая перезарядка",
  scanLogin:
    "Для обеспечения конфиденциальности и безопасности учетной записи, пожалуйста, отсканируйте код для входа в систему.",
  scanTip:
    "Совет: нажмите «Сканировать» в правом верхнем углу Tada «Персональный центр / Динамика», чтобы отсканировать код для входа в систему. В то же время он поддерживает вход, идентифицируя снимок экрана с QR-кодом.",
  scanVersion:
    "Обновите Tada до версии %s и отсканируйте код, чтобы войти в систему.",
  delAccount: "Удаление аккаунта",
  logout: "Выйти",
  submit: "Отправить",
  email_place_holder: "Введите свой почтовый ящик",
  contact_email: "Почта для связи",
  provide_email:
    "Пожалуйста, укажите свой адрес электронной почты, чтобы получать уведомление о платеже",
  email_address: "Адрес электронной почты",
};



// WEBPACK FOOTER //
// ./src/lang/ru.js